import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { IFileSettings } from 'core-components/library/dragNDropFileUploader'

import { uploadContactImage as uploadContactImageApi } from '../api/uploadContactImage'
import { UPLOAD_CONTACT_IMAGE } from '../model/constants'
import { IPartnerContact } from '../model/types'
import { selectContactsFilters } from '../selectors/selectContactsFilters'

interface IUploadContactImageParams {
  fileSettings: IFileSettings
  contact: IPartnerContact
}

export const uploadContactImage = createAsyncThunk<IPartnerContact, IUploadContactImageParams>(
  UPLOAD_CONTACT_IMAGE,
  async ({ fileSettings, contact }, { getState }) => {
    const { partnerId, programType } = selectContactsFilters(getState())

    if (!partnerId || !programType) {
      throw new Error('Partner ID and program type are required to upload contact image')
    }

    await uploadContactImageApi({
      partnerId,
      programType,
      filesInfo: [fileSettings],
      contact,
    })

    return {
      ...contact,
      Image: fileSettings.file.name,
    }
  }
)
